import { render, staticRenderFns } from "./VideoRunRow.vue?vue&type=template&id=561c0e75&scoped=true"
import script from "./VideoRunRow.vue?vue&type=script&lang=js"
export * from "./VideoRunRow.vue?vue&type=script&lang=js"
import style0 from "./VideoRunRow.vue?vue&type=style&index=0&id=561c0e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c0e75",
  null
  
)

export default component.exports